import React, { useEffect, useRef, useState } from "react";
import classNames from "classnames/bind";
import styles from "./Alert.module.css";
import success from "../../assets/images/Success.png";


const cx = classNames.bind(styles);
const AlertInstallPlugin = ({ onClose, onOk, type = "alert", href, title, content, onCheck }) => {
  const refModal = useRef();
  const [showInput, setInput] = useState(false)
  const handleCancel = () => {
    onClose();
  };
  const handleOk = () => {
    onOk();
  };

  useEffect(() => {
    const handleCloseOnClickOutSide = (e) => {
      if (e.target === refModal.current) {
        handleCancel();
      }
    };
    document.addEventListener("click", handleCloseOnClickOutSide);
    return () => {
      document.removeEventListener("click", handleCloseOnClickOutSide);
    };
    // eslint-disable-next-line
  }, []);
  return (
    <div className={cx("content")} ref={refModal}>
      <div className={cx("container")}>
        <div className={cx("img")}>
          <img src={success} alt="Ảnh cảnh báo" />
        </div>
        <div className={cx("description")}>
          <span className={cx("name")}>{title}</span>
          <span className={cx("title")}>{content}</span>
        </div>
        <div className={cx("actions")}>
        </div>
      </div>
    </div>
  );
};
export default AlertInstallPlugin;
